export default __webpack_public_path__ + "static/media/shubham.3c3b1196.jpg";